import {
  fetchTemplatesFailure,
  fetchTemplatesRequest,
  fetchTemplatesSuccess,
  resetTemplates,
} from './reducers';

export {
  fetchTemplatesFailure,
  fetchTemplatesRequest,
  fetchTemplatesSuccess,
  resetTemplates,
};

export const FETCH_TEMPLATES_REQUEST = fetchTemplatesRequest.type;
export const FETCH_TEMPLATES_SUCCESS = fetchTemplatesSuccess.type;
export const FETCH_TEMPLATES_FAILURE = fetchTemplatesFailure.type;
export const RESET_TEMPLATES = resetTemplates.type;
